export const environment = {
  production: true,
  backendUrl: 'https://webshop-api.sjoborgs.se/',
  isAssortmentBasedNavigation: true
};
